import { AccountInterface, AccountKind, FeatureFlagKey, OrgInterface } from "@swivl-mono/types";

const KIND_RANK: Record<AccountKind, number> = {
  [AccountKind.Customer]: 0,
  [AccountKind.SwivlStaff]: 1,
  [AccountKind.SwivlAdmin]: 2
};

type AccountForFlag = Pick<AccountInterface, "kind"> | null | undefined;
type OrgForFlag = Pick<OrgInterface, "featureFlags"> | null | undefined;

// Pure resolver: a feature is enabled for an account on an org iff:
//   1. The org has explicitly set the flag (org.featureFlags[key] is an AccountKind).
//   2. The account's kind ranks at or above that minimum.
// Missing key on the org = feature is off on that org. No magic bypass: even
// SwivlAdmin only sees features the org owner has explicitly enabled on the org.
// App code should call the app-bound `isFeatureEnabled(flag)` rather than this
// directly; this is the low-level primitive it wraps.
export function resolveFeatureFlag(account: AccountForFlag, org: OrgForFlag, key: FeatureFlagKey): boolean {
  const minKind = org?.featureFlags?.[key];
  if (!minKind) return false;
  const accountKind = account?.kind ?? AccountKind.Customer;
  return KIND_RANK[accountKind] >= KIND_RANK[minKind];
}
